export const contentTypes = [
  {
    text: 'x-www-form-urlencoded',
    value: 'x-www-form-urlencoded'
  },
  {
    text: 'application/json',
    value: 'application/json'
  }
];
